/**
 * Do nothing.
 */
export const noop = () => {};

/**
 * Determine if a given value is not an Object with one or more properties.
 *
 * @param {*} value The value under test
 * @return {Boolean} false if the value is an Object with one or more properties, true otherwise
 */
export const isEmptyObject = (obj: any): boolean => {
  if (obj == null || typeof obj === 'string') {
    return true;
  }

  if (typeof obj === 'object' && obj !== null) {
    return Object.keys(obj).length === 0;
  }

  return true;
};
